<template>
  <div class="voucher-date-cell">
    <template>
      <div style="display: flex; align-items: center; justify-content: center;">
        <span>{{ showDate ? formatDate(voucherList[0].voucherDate) : ColumnUtils.voucherStateLabelFunc(voucherList[0].voucherStatus) }}</span>
        <el-popover
          placement="right"
          width="400"
          trigger="hover"
        >
          <el-table :data="voucherList" size="mini" border>
            <el-table-column prop="voucherNo" :label="$t('CargoMsg.Cargo_VoucherNo')" width="120" />
            <el-table-column prop="voucherDate" :label="$t('CargoMsg.Cargo_ProofDate')" width="150" :formatter="formatDateByCell" />
            <el-table-column prop="voucherStatus" :label="$t('CargoMsg.Cargo_VoucherStatus')" width="120" :formatter="voucherStatusFormatter" />
          </el-table>
          <i slot="reference" class="el-icon-info" style="font-size: 15px; margin-left: 10px" />
        </el-popover>
      </div>
    </template>

  </div>
</template>

<script>
import moment from 'moment'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'VoucherDatePopover',
  computed: {
    ColumnUtils() {
      return ColumnUtils
    },
    voucherList() {
      return this.params.data.receiptPaymentpVoucherList || []
    },
    showDate() {
      return this.params.colDef.field === 'receiptPaymentpVoucherDate'
    }
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('YYYY-MM-DD') : ''
    },
    formatDateByCell(row, column, cellValue, index) {
      return cellValue ? moment(cellValue).format('YYYY-MM-DD') : ''
    },
    voucherStatusFormatter(row, column, cellValue, index) {
      // 调用 ColumnUtils.voucherStateLabelFunc 方法，传入 cellValue
      return ColumnUtils.voucherStateLabelFunc(cellValue)
    }
  }
}
</script>

<style lang="scss">
.voucher-date-cell {
  width: 100%;
  height: 100%;
  display: flex;

  .voucher-table {
    border-collapse: collapse;
    width: 100%;

    th, td {
      border: 1px solid #EBEEF5;
      padding: 8px;
      text-align: center;
    }

    th {
      background-color: #F5F7FA;
    }
  }
}
</style>
